import Vue from "vue"
import App from "./App.vue"
import "./registerServiceWorker"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import Moment from "moment"
import VueSession from "vue-session"
import IdleVue from "idle-vue"
import VueIziToast from "vue-izitoast"
import _BUGSNAG from "./libs/_BUGSNAG"
import _EVENTBUS from "./store/_EVENTBUS"
import "izitoast/dist/css/iziToast.min.css"
import {
  _HASPERMISSION,
  _ISALLOWED,
  _ISDISABLED,
  _ISSUPER,
  _ISUSER
} from "./store/_PERMISSIONS"
import VueCookies from "vue-cookies"
Vue.config.productionTip = false

// -- GLOBAL VARIABLES

Vue.prototype.$eventBus = _EVENTBUS
Vue.prototype.$toastPosition = "topRight"
Vue.prototype.$toastTimeout = "3000"
Vue.prototype.$loadTimeout = 1000
Vue.prototype.$imagemsUrl = process.env.VUE_APP_API + "/hemaapi/api/image"
Vue.prototype.$filesUrl = process.env.VUE_APP_API + "/hemaapi/api/file"
Vue.prototype.$moment = Moment
Vue.prototype.$moment.locale("pt")
Vue.prototype.$holdTime = 1000

Vue.prototype.$_HASPERMISSION = _HASPERMISSION
Vue.prototype.$_ISALLOWED = _ISALLOWED
Vue.prototype.$_ISDISABLED = _ISDISABLED
Vue.prototype.$_ISSUPER = _ISSUPER
Vue.prototype.$_ISUSER = _ISUSER

Vue.prototype.$cotas = "12.00"

Vue.prototype.$success = "Operação efetuada com sucesso!"
Vue.prototype.$error = "Ocorreu um erro ao efetuar a operação!"
Vue.prototype.$requiredField = "* Campo obrigatório"
Vue.prototype.$_BUGSNAG = _BUGSNAG

// -- DEPENDENCIES

var options = {
  persist: true
}
Vue.use(VueSession, options)

Vue.use(IdleVue, {
  eventEmitter: _EVENTBUS,
  idleTime: 3600000
})

Vue.use(VueIziToast)
Vue.use(VueCookies)
// -- COLORS

Vue.prototype.$primary = "#E53935"

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  onIdle() {
    this.$eventBus.$emit("logout")
  }
}).$mount("#app")
